import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { PhoneAuthCard } from "@/entities/authorization/phone-auth-card.tsx";
import { CodeAuthCard } from "@/entities/authorization/code-auth-card.tsx";

export const Route = createFileRoute("/login")({
  component: Index,
});

function Index() {
  const [phone, setPhone] = useState<string | undefined>();

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-[#F5F5F5]">
      <div>
        {!phone && <PhoneAuthCard setPhone={setPhone} />}
        {phone && <CodeAuthCard phone={phone} setPhone={setPhone} />}
      </div>
    </div>
  );
}
